<template>
  <div class="animated fadeIn">
    <b-row class="mb-4 d-lg-none">
      <b-col>
        <b-button
          variant="warning"
          :to="{name: 'แก้ไขข้อมูลบริษัท'}"
          block
          no-caret
        >สร้าง/แก้ไข โปรไฟล์ของคุณในระบบ</b-button>
      </b-col>
    </b-row>
    <b-row class="d-md-down-none">
      <b-col>
        <b-button
          class="float-right"
          variant="warning"
          :to="{name: 'แก้ไขข้อมูลบริษัท'}"
          no-caret
        >สร้าง/แก้ไข โปรไฟล์ของคุณในระบบ</b-button>
      </b-col>
    </b-row>
    <b-row class="text-center">
      <b-col>
        <b-img src="/img/twoLevel_Blue_512 300 dpi.png" height="75" />
        <!-- <div style="font-size: 2em;">Logisty</div> -->
        <div class="mt-3">
          <h5>ค้นหาผู้ให้บริการขนส่ง</h5>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-card>
          <h5 class="mb-4">เริ่มต้นค้นหาผู้ให้บริการขนส่งโดยใช้ตัวกรอง (filter) ด้านล่าง</h5>
          <b-row>
            <b-col sm="12">
              <label for="name">ชื่อบริษัท</label>
              <b-input-group>
                <b-form-input v-model="name" id="name" v-on:keyup.enter="doSearch"></b-form-input>
                <!-- <b-input-group-append>
                  <b-button variant="primary">ค้นหา</b-button>
                </b-input-group-append>-->
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col lg="6" xl="4">
              <MultiSelectTruckTag label="ชนิดรถ" v-model="truckType" />
            </b-col>
            <b-col lg="6" xl="4">
              <MultiSelectTag
                label="พื้นที่ให้บริการ"
                v-model="serviceArea"
                :options="serviceAreaOptions"
              />
            </b-col>
            <b-col lg="6" xl="4">
              <MultiSelectTag
                label="ที่ตั้ง/ลานจอด"
                v-model="parkingBase"
                :options="parkingBaseOptions"
              />
            </b-col>
            <b-col lg="6" xl="4">
              <MultiSelectTag
                label="งานที่เคยรับ"
                v-model="natureOfCargo"
                :options="natureOfCargoOptions"
              />
            </b-col>
            <b-col lg="6" xl="4">
              <MultiSelectTag
                label="วิ่งข้ามชายแดน"
                v-model="crossThaiBorder"
                :options="crossThaiBorderOptions"
              />
            </b-col>
          </b-row>
          <!-- <b-row class="mt-3">
            <b-col>
              <b-form-checkbox
                id="backHaulReq"
                v-model="backHaulReq"
                :value="true"
                :unchecked-value="false"
              >มองหางานเที่ยวกลับ</b-form-checkbox>
            </b-col>
          </b-row> -->
          <b-row v-if="backHaulReq" class>
            <b-col sm="12">
              <b-row class="p-2">
                <b-col sm="12" xl="4">
                  <MultiSelectTag label="จาก" v-model="backHaulFrom" :options="serviceAreaOptions" />
                </b-col>
                <b-col sm="12" xl="4">
                  <MultiSelectTag label="ไปยัง" v-model="backHaulTo" :options="serviceAreaOptions" />
                </b-col>
                <!-- <b-col lg="12" xl="4">
                  <MultiSelectTag
                    label="ชนิดรถเที่ยวกลับ"
                    v-model="backHaulTruckType"
                    :options="truckTypeOptions"
                  />
                </b-col>-->
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-button variant="primary" @click="doSearch(true)">ค้นหา</b-button>
              <b-button variant="warning" class="ml-3" @click="resetSearch">ล้างค่า</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card

          header-text-variant="logisty-dark-main"
          ref="company-list"
        >
          <template v-slot:header>
            <b-row>
              <b-col sm="12" md="6" align-self="center">
                {{ 'ผู้ให้บริการในระบบ ' + rows + ' ราย' }}
              </b-col>
              <b-col sm="12" md="6" align-self="center">
                <div class="float-right">
                  <b-form-select v-model="sortBy" :options="sortOptions" size="sm" @input="doSort"></b-form-select>
                </div>
              </b-col>
            </b-row>
          </template>
          <b-link
            :to="{name: 'โปรไฟล์', params: {companyUrl:item.profileUrl}}"
            target="_blank"
            tag="div"
            v-for="(item, index) in items"
            v-bind:key="index"
          >
            <b-row>
              <b-col xs="12" sm="3" md="3" lg="2" xl="1" class="text-center" align-self="center">
                <div class="d-none d-sm-block">
                  <b-img v-if="!item.logo.imgBase64" src="/img/icon/No_image.png" width="100" height="100" fluid />
                  <b-img
                    v-else
                    :src="'data:image/jpeg;base64,'+item.logo.imgBase64"
                    width="100"
                    height="100"
                    fluid
                  />
                </div>
                <div class="d-block d-sm-none profile-logo">
                  <b-img v-if="!item.logo.imgBase64" src="/img/icon/No_image.png" />
                  <b-img v-else :src="'data:image/jpeg;base64,'+item.logo.imgBase64"
                  />
                </div>
              </b-col>
              <b-col xs="12" sm="9" md="9" lg="10" xl="11">
                <div class="text-logisty-dark-main search-company-name">
                  <b>{{ item.name }}</b>
                </div>
                <div class="text-muted search-company-address">{{ item.address }}</div>
                <div class="text-right">ดูรายละเอียด</div>
              </b-col>
              <!-- <b-col xs="12" sm="3" md="3" class="text-center" align-self="center">
                <b-button
                  v-if="item.profileUrl"
                  variant="primary"
                  :to="{name: 'โปรไฟล์', params: {companyUrl:item.profileUrl}}"
                  target="_blank"
                >ดูรายละเอียด</b-button>
                <span v-else class="text-danger">ยังไม่มีข้อมูล</span>
              </b-col>-->
            </b-row>
            <b-row>
              <b-col>
                <hr class="divider" />
              </b-col>
            </b-row>
          </b-link>
          <b-row class="mt-3">
            <b-col>
              <b-pagination
                class="flex-wrap"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-text="หน้าแรก"
                prev-text="ก่อนหน้า"
                next-text="ถัดไป"
                last-text="หน้าสุดท้าย"
                @input="updatePage"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>

import MultiSelectTag from '../components/MultiSelectTag'
import MultiSelectTruckTag from '../components/MultiSelectTruckTag'

import Profile from '../services/http/Profile'
import ModalLoading from '../components/ModalLoading'

export default {
  name: 'home',
  components: {
    ModalLoading,
    MultiSelectTag,
    MultiSelectTruckTag
  },
  data () {
    return {
      items: [],
      rows: 0,
      perPage: 10,
      currentPage: 1,
      name: null,
      serviceArea: [],
      itemscache: [],
      backHaulFrom: [],
      backHaulTo: [],
      backHaulReq: false,
      backHaulTruckType: [],
      serviceAreaOptions: [
        { value: 'ภาคเหนือ' },
        { value: 'ภาคตะวันออกเฉียงเหนือ' },
        { value: 'ภาคกลาง' },
        { value: 'ภาคตะวันออก' },
        { value: 'ภาคตะวันตก' },
        { value: 'ภาคใต้' }
      ],
      crossThaiBorder: [],
      crossThaiBorderOptions: [
        { value: 'พม่า' },
        { value: 'ลาว' },
        { value: 'กัมพูชา' },
        { value: 'มาเลเซีย' }
      ],
      truckType: [],
      truckTypeOptions: [
        { value: '4 ล้อ ตู้ทึบ' },
        { value: '4 ล้อ ตู้เย็น' },
        { value: '4 ล้อ คอกสูง' },
        { value: '4 ล้อ จัมโบ้ ตู้ทึบ' },
        { value: '4 ล้อ จัมโบ้ ตู้เย็น' },
        { value: '4 ล้อ จัมโบ้ คอก' },
        { value: '6 ล้อตู้ทึบ 5.5 เมตร' },
        { value: '6 ล้อตู้ทึบ 6.5 เมตร' },
        { value: '6 ล้อตู้ทึบ 7 เมตร' },
        { value: '6 ล้อคอกสูง 5.5 เมตร' },
        { value: '6 ล้อคอกสูง 6.5 เมตร' },
        { value: '6 ล้อคอกสูง 7 เมตร' },
        { value: '6 ล้อ ตู้เย็น' },
        { value: '6 ล้อพื้นเรียบ' },
        { value: '6 ล้อเครน' },
        { value: '6 ล้อกระบะคาร์โก้' },
        { value: '10 ล้อตู้ทึบ' },
        { value: '10 ล้อคอกสูง' },
        { value: '10 ล้อคอกสูงดัมพ์' },
        { value: '10 ล้อคอกตํ่า' },
        { value: '10 ล้อคอกตํ่าดัมพ์' },
        { value: '10 ล้อ ตู้เย็น' },
        { value: '10 ล้อพื้นเรียบ' },
        { value: '10 ล้อเครน' },
        { value: '10 ล้อแทงเกอร์' },
        { value: '10 ล้อกระบะคาร์โก้' },
        { value: 'พ่วงคอกตํ่า' },
        { value: 'พ่วงคอกตํ่าดัมพ์' },
        { value: 'พ่วงคอกสูง' },
        { value: 'พ่วงคอกสูงดัมพ์' },
        { value: 'พ่วงตู้ทึบ' },
        { value: 'พ่วงพื้นเรียบ' },
        { value: 'หัวลาก' },
        { value: 'เทรลเลอร์หางก้าง' },
        { value: 'เทรลเลอร์หางพื้นเรียบ' },
        { value: 'เทรลเลอร์หางพื้นเรียบชานต่ำ (Low Bed)' },
        { value: 'เทรลเลอร์หางม่านข้าง' },
        { value: 'เทรลเลอร์หางคอก' },
        { value: 'เทรลเลอร์หางคอกดั๊มพ์' },
        { value: 'เทรลเลอร์หางตู้เย็น 40ft' },
        { value: 'เทรลเลอร์หางตู้เย็น 20ft' },
        { value: 'เทรลเลอร์หางแทงเกอร์' }
        // { value: 'เทรลเลอร์หางตู้คอนเทนเนอร์ 40ft' },
        // { value: 'เทรลเลอร์หางตู้คอนเทนเนอร์ 20ft' }
      ],
      parkingBase: [],
      parkingBaseOptions: [
        { value: 'กระบี่' },
        { value: 'กรุงเทพมหานคร' },
        { value: 'กาญจนบุรี' },
        { value: 'กาฬสินธุ์' },
        { value: 'กำแพงเพชร' },
        { value: 'ขอนแก่น' },
        { value: 'จันทบุรี' },
        { value: 'ฉะเชิงเทรา' },
        { value: 'ชลบุรี' },
        { value: 'ชัยนาท' },
        { value: 'ชัยภูมิ' },
        { value: 'ชุมพร' },
        { value: 'เชียงราย' },
        { value: 'เชียงใหม่' },
        { value: 'ตรัง' },
        { value: 'ตราด' },
        { value: 'ตาก' },
        { value: 'นครนายก' },
        { value: 'นครปฐม' },
        { value: 'นครพนม' },
        { value: 'นครราชสีมา' },
        { value: 'นครศรีธรรมราช' },
        { value: 'นครสวรรค์' },
        { value: 'นนทบุรี' },
        { value: 'นราธิวาส' },
        { value: 'น่าน' },
        { value: 'บุรีรัมย์' },
        { value: 'บึงกาฬ' },
        { value: 'ปทุมธานี' },
        { value: 'ประจวบคีรีขันธ์' },
        { value: 'ปราจีนบุรี' },
        { value: 'ปัตตานี' },
        { value: 'พระนครศรีอยุธยา' },
        { value: 'พะเยา' },
        { value: 'พังงา' },
        { value: 'พัทลุง' },
        { value: 'พิจิตร' },
        { value: 'พิษณุโลก' },
        { value: 'เพชรบุรี' },
        { value: 'เพชรบูรณ์' },
        { value: 'แพร่' },
        { value: 'ภูเก็ต' },
        { value: 'มหาสารคาม' },
        { value: 'มุกดาหาร' },
        { value: 'แม่ฮ่องสอน' },
        { value: 'ยโสธร' },
        { value: 'ยะลา' },
        { value: 'ร้อยเอ็ด' },
        { value: 'ระนอง' },
        { value: 'ระยอง' },
        { value: 'ราชบุรี' },
        { value: 'ลพบุรี' },
        { value: 'เลย' },
        { value: 'ลำปาง' },
        { value: 'ลำพูน' },
        { value: 'ศีรสะเกษ' },
        { value: 'สกลนคร' },
        { value: 'สงขลา' },
        { value: 'สตูล' },
        { value: 'สมุทรปราการ' },
        { value: 'สมุทรสงคราม' },
        { value: 'สมุทรสาคร' },
        { value: 'สระแก้ว' },
        { value: 'สระบุรี' },
        { value: 'สิงห์บุรี' },
        { value: 'สุโขทัย' },
        { value: 'สุพรรณบุรี' },
        { value: 'สุราษฎร์ธานี' },
        { value: 'สุรินทร์' },
        { value: 'หนองคาย' },
        { value: 'หนองบัวลำภู' },
        { value: 'อ่างทอง' },
        { value: 'อำนาจเจริญ' },
        { value: 'อุดรธานี' },
        { value: 'อุตรดิตถ์' },
        { value: 'อุทัยธานี' },
        { value: 'อุบลราชธานี' }
      ],
      businessType: [],
      businessTypeOptions: [
        { value: 'บริษัทขนส่ง' },
        { value: 'ชิปปิ้งและเฟรทฟอร์เวิดเดอร์' },
        { value: 'โกดังสินค้า' },
        { value: 'ผู้ผลิต' }
      ],
      natureOfCargo: [],
      natureOfCargoOptions: [
        { value: 'สินค้าทั่วไป สินค้าอุปโภคบริโภค' },
        { value: 'สินค้าส่งเข้า DC' },
        { value: 'ตู้คอนเทนเนอร์ นำเข้า / ส่งออก' },
        { value: 'หิน ดิน ทราย แร่' },
        { value: 'น้ำมัน / สารเคมี / เม็ดพลาสติก / วัตถุอันตราย' },
        { value: 'สินค้าเกษตร' },
        { value: 'ชิ้นส่วนยานยนต์' },
        { value: 'เครื่องใช้ไฟฟ้า / อิเล็กทรอนิกส์' },
        { value: 'สินค้ามูลค่าสูง (เช่น เครื่องประดับ นาฬิกา)' },
        { value: 'สินค้าแช่เย็น / แช่แข็ง' },
        { value: 'สินค้าขนาดใหญ่พิเศษ เครื่องจักร' },
        { value: 'วัสดุก่อสร้าง' },
        { value: 'เครื่องดื่ม' },
        { value: 'รถยนต์' },
        { value: 'ยาและเครื่องสำอางค์' }
      ],
      sortBy: 'desc',
      sortOptions: [
        { value: 'desc', text: 'เรียงจาก ก-ฮ' },
        { value: 'asc', text: 'เรียงจาก ฮ-ก' },
        { value: 'truck-desc', text: 'เรียงจากจำนวนรถ น้อย-มาก' },
        { value: 'truck-asc', text: 'เรียงจากจำนวนรถ มาก-น้อย' }
      ]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      // var profile = new Profile()

      // var result = await profile.searchPublicProfile({
      //   limit: 10
      // })

      // if (result.code === 1) {
      //   this.rows = result.data.length
      //   this.item = result.data
      // }

      // console.log(result)
      this.doSearch()
    },
    async doSearch (showPopup = false) {
      // console.log(this.businessType)
      Window.Event.$emit('showModalLoading')
      var data = {
        limit: 99999
      }

      if (this.name) {
        data = {
          ...data,
          name: this.name
        }
      }

      var filterBy = {
        'name': { '$ne': null },
        'profileUrl': { '$ne': null },
        'businessType': { '$in': ['บริษัทขนส่ง'] },
        'carrierStatus': 1
      }

      if (this.serviceArea.length > 0) {
        filterBy = {
          ...filterBy,
          'serviceArea': { '$in': this.textObjToArr(this.serviceArea) }
        }
      }

      if (this.parkingBase.length > 0) {
        filterBy = {
          ...filterBy,
          'parkingBase': { '$in': this.textObjToArr(this.parkingBase) }
        }
      }

      if (this.natureOfCargo.length > 0) {
        filterBy = {
          ...filterBy,
          'natureOfCargo': { '$in': this.textObjToArr(this.natureOfCargo) }
        }
      }

      if (this.truckType.length > 0) {
        var temp = this.truckType.map((x) => {
          return {
            'ownTruckNumByType': {
              '$elemMatch': {
                'value': {
                  '$gt': 0
                },
                'name': x.typeName
              }
            }
          }
        })

        filterBy = {
          ...filterBy,
          '$or': temp
        }
      }

      if (this.backHaulReq) {
        let fbTemp = {
          'backhaulRequest': {
            '$elemMatch': {
            }
          }
        }
        if (this.backHaulFrom.length > 0) {
          fbTemp['backhaulRequest']['$elemMatch']['from'] = {
            '$in': this.textObjToArr(this.backHaulFrom)
          }
        }
        if (this.backHaulTo.length > 0) {
          fbTemp['backhaulRequest']['$elemMatch']['to'] = {
            '$in': this.textObjToArr(this.backHaulTo)
          }
        }
        if (this.truckType.length > 0) {
          fbTemp['backhaulRequest']['$elemMatch']['truckType'] = {
            '$in': this.textObjToArr(this.truckType)
          }
        }
        filterBy = {
          ...filterBy,
          ...fbTemp
        }
      }

      if (this.crossThaiBorder.length > 0) {
        filterBy = {
          ...filterBy,
          'crossThaiBorder': { '$in': this.textObjToArr(this.crossThaiBorder) }
        }
      }

      data = {
        ...data,
        filterBy: filterBy,
        sortBy: {
          'name': 1
        }
      }

      window.analytics.track('search-company', {
        name: this.name,
        serviceArea: this.textObjToArr(this.serviceArea),
        parkingBase: this.textObjToArr(this.parkingBase),
        natureOfCargo: this.textObjToArr(this.natureOfCargo)
      })

      var profile = new Profile()

      try {
        var result = await profile.searchPublicProfile(data)
        if (result.code === 1) {
          //  console.log(result)
          this.rows = result.data.length
          // var start = (this.currentPage - 1) * this.perPage
          // var end = start + this.perPage
          // console.log(start, end)
          this.itemscache = result.data
          this.doSort()
          // this.items = result.data.slice(start, end)

          // console.log(this.items)

          // show pop-up result
          if (showPopup) {
            // jump to list

            // display success message
            let resultText = 'คนพบ ' + result.data.length + ' ผู้ให้บริการ'
            await this.$bvModal.msgBoxOk(resultText, this.$getConst('okModalClass'))
            this.jumpToList()
          }
        }
      } catch (error) {
        alert('โปรดติดต่อผู้ดูแลระบบ')
        console.log(error)
      }

      Window.Event.$emit('closeModalLoading')
    },
    textObjToArr (obj) {
      var out = obj.map(x => x.value)
      return out
    },
    ArrToTextObj (arr) {
      if (arr) {
        var out = arr.map((x) => {
          return { value: x }
        })

        return out
      } else {
        return []
      }
    },
    resetSearch () {
      this.name = null
      this.truckType = []
      this.serviceArea = []
      this.parkingBase = []
      this.natureOfCargo = []
      this.backHaulFrom = []
      this.backHaulTo = []
      this.backHaulTruckType = []
      this.crossThaiBorder = []
      this.backHaulReq = false
      window.analytics.track('search-clear')
      this.doSearch()
    },
    updatePage () {
      // console.log(this.currentPage)
      // this.doSearch()
      var start = (this.currentPage - 1) * this.perPage
      var end = start + this.perPage
      this.items = this.itemscache.slice(start, end)
    },
    doSort () {
      switch (this.sortBy) {
        case 'desc':
          this.itemscache.sort((a, b) => a.name.localeCompare(b.name))
          break
        case 'asc':
          this.itemscache.sort((a, b) => b.name.localeCompare(a.name))
          break
        case 'truck-desc':
          this.itemscache.sort((a, b) => {
            // let sumA = a.ownTruckNumByType.reduce((accum, item) => accum + item.name.includes('หาง') ? 0 : item.value, 0)
            // let sumB = b.ownTruckNumByType.reduce((accum, item) => accum + item.name.includes('หาง') ? 0 : item.value, 0)
            let sumA = 0
            a.ownTruckNumByType.forEach((x) => {
              if (!x.name.includes('หาง')) {
                sumA = sumA + x.value
              }
            })
            let sumB = 0
            b.ownTruckNumByType.forEach((x) => {
              if (!x.name.includes('หาง')) {
                sumB = sumB + x.value
              }
            })
            return sumA - sumB
          })
          break
        case 'truck-asc':
          this.itemscache.sort((a, b) => {
            // let sumA = a.ownTruckNumByType.reduce((accum, item) => accum + item.name.includes('หาง') ? 0 : item.value, 0)
            // let sumB = b.ownTruckNumByType.reduce((accum, item) => accum + item.name.includes('หาง') ? 0 : item.value, 0)
            let sumA = 0
            a.ownTruckNumByType.forEach((x) => {
              if (!x.name.includes('หาง')) {
                sumA = sumA + x.value
              }
            })
            let sumB = 0
            b.ownTruckNumByType.forEach((x) => {
              if (!x.name.includes('หาง')) {
                sumB = sumB + x.value
              }
            })
            return sumB - sumA
          })
          break
        default:
          break
      }
      this.updatePage()
    },
    jumpToList () {
      let element = this.$refs['company-list']
      this.$scrollTo(element)
    }
  },
  watch: {
    backHaulReq (val) {
      if (!val) {
        this.backHaulFrom = []
        this.backHaulTo = []
      }
    }
  }
}
</script>
